import { ReactElement } from "react";
import { StepStatus } from "_/data/projects";
import { IconVariant } from "_/components/icon";
import * as S from "./styled";

export function iconForStepStatus(
  status: Exclude<StepStatus, "pending" | "running">
): IconVariant {
  switch (status) {
    case "completed":
      return "CheckCircle";
    case "failed":
      return "Error";
    case "skipped":
      return "CheckCircle";
    case "warning":
      return "Error";
    default:
      return "Info";
  }
}

export const StepSymbol = ({
  status,
}: {
  status: StepStatus;
}): ReactElement => {
  if (status === "pending") return <S.PendingDot />;
  if (status === "running") return <S.RunningSpinner />;
  return <S.StepIcon $status={status} variant={iconForStepStatus(status)} />;
};
